import { useQuery } from "@tanstack/react-query";
import { client } from "../../../../api/client";

interface ReportsStatistics {
  totalReports: number;
  availableReports: number;
  availableAndNotDownloadedReports: number;
}

export const useReportsStatistics = () => {
  return useQuery<ReportsStatistics>({
    queryKey: ["reports", "statistics"],
    queryFn: async () => {
      const response = await client.get("/reports/statistics");
      return response.data;
    },
  });
};
